import { ChevronDown } from 'lucide-react'
import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import type { SectionId } from '@/teams/portfolio/types/section-id.ts'
import '@/teams/portfolio/components/scroll-indicator/scroll-indicator.scss'

interface ScrollIndicatorProps {
	targetSection: SectionId
}

export function ScrollIndicator({
	targetSection,
}: Readonly<ScrollIndicatorProps>) {
	const { t } = useTranslation()

	const handleScrollClick = () => {
		const element = document.getElementById(targetSection)
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' })
		}
	}

	return (
		<button
			aria-label={t('shared.common.scrollHint')}
			className='scroll-indicator'
			data-testid={'scroll-indicator'}
			onClick={handleScrollClick}
			type='button'>
			<ChevronDown aria-hidden='true' className='scroll-indicator__icon' />
		</button>
	)
}
